import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import '../modals.js';
import './videoSelectionInputModal.js';
import 'prop-types';
import 'react';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-common';
import '../style-inject.es-746bb8ed.js';
import 'react-player';
import '../types.js';
import './videoPluginService.js';
import 'lodash';
import './VideoSettings.js';
import 'classnames';
import './ControlsSection.js';
import './videoModal.js';
import './mediaURLInputModal.js';
import './NewVideoModal.js';
import './NewVideoInsertModal.js';
import './videoUploadModal.js';
import './NewMediaUrlInputModal.js';
import 'ricos-context';
import './selectionModalCustomStyles.js';
import '../constants.js';
import 'ricos-schema';
import '../icons/MediaReplaceIcon.js';
import '../video-component.js';
import 'react-dom';
import '../video-viewer.js';
import '../reactPlayerWrapper.js';
import 'wix-rich-content-common/dist/statics/schemas/plugin-video.schema.json';
import '../get-video-source.js';
import '../IframePlayer.js';
import '../video-viewer-5a066449.js';
import '../default-video-styles-c99083e5.js';
import '../icons/VideoInsertPluginIcon.js';
import '../icons/SoundCloudInsertPluginIcon.js';
import '../icons/YoutubeIcon.js';

const createToolbar = ({
  t,
  settings,
  isMobile,
  disableDownload,
  experiments
}) => {
  return {
    InlineButtons: createInlineButtons({ t, settings, isMobile, experiments }),
    InsertButtons: createInsertButtons({ t, settings, isMobile, disableDownload, experiments }),
    name: "video"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
